exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.underline[data-v-5f249912]{\n  text-decoration: underline;\n}\np[data-v-5f249912]{\n  margin-bottom: 0px;\n}\n.watermark[data-v-5f249912] {\n  position: relative;\n}\n.watermark[data-v-5f249912]::after {\n  content: \"\";\n  background-image: url('/static/img/rotate-main-logo.svg');\n  opacity: 0.15;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-size: contain;\n}\ntable.translate-law tbody tr td[data-v-5f249912]:first-child {\n  font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5f249912","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/professional/Agreement.vue
// module id = 2006
// module chunks = 0